import classnames from 'classnames';
import PropTypes from 'prop-types';

import Message from './message';
import { BannerStatus } from '../../ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from '../../ui-components/components/banner-message/banner-message-v2';
import { useFulfillmentPlannerContext } from '../context';
import style from './style.module.less';

const FulfillmentPlannerError = ({ className = null }) => {
  const { labelCreationErrors, didLabelCreationFail } = useFulfillmentPlannerContext();
  const errorMessagesToShow = didLabelCreationFail ? labelCreationErrors : undefined;
  if (!errorMessagesToShow || !errorMessagesToShow.length) {
    return null;
  }

  const classes = classnames(style['error-container'], className);
  return (
    <div className={classes}>
      <div className={style['column-of-errors']}>
        <BannerMessageV2
          content={
            <>
              {labelCreationErrors.map((msg) => (
                <Message key={msg} childClassName={style['message-style']} errorMessage={msg} />
              ))}
            </>
          }
          status={BannerStatus.Error}
        />
      </div>
    </div>
  );
};

FulfillmentPlannerError.propTypes = {
  className: PropTypes.string,
};

export default FulfillmentPlannerError;
